import React, { useState, useEffect } from 'react';
import {
    Modal,
    Box,
    TextField,
    Button,
    Select,
    MenuItem,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    IconButton, FormControl, InputLabel
} from '@mui/material';
import {
    getSlides,
    getPDFFolders,
    getVideoFolders,
    getAudioFolders,
    getAudios,
    getVideos,
    getPDFs,
    createLink,
    updateLink,
    addSlideToChapter,
    getChapters,
    getLinkSlides,
    addSlideToLink,
    getLink,
    deleteLinkSlide,
    fetchProjects,
    getMultiDirections, deleteMultiDirection, fetchScenario, getScenarios, getVisits, addMultiDirection, addScaenario
} from '../services/api';
import {Slide, Link, LinkSlide, LinkEdit, MultiDirection, Visit, Scenario} from "../services/types";
import {ArrowBack, Backup, ArrowRight,ArrowLeft, Delete} from "@mui/icons-material";
import {SelectChangeEvent} from "@mui/material/Select";

interface SlideImage {
    id: string;
    url: string;
}
interface LinkEditModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSaveLink: (linkdData: LinkEdit | null, linkSlides: SlideImage[]) => void;
    link: Link;
    slideId: string;
    projectId: string;
}
interface Presentation {
    id: string;
    name: string;
    photo_url: string;
    clm_type_id: string;
    // Add other properties as needed
}

function moveIdBack(items: SlideImage[], targetId: string): SlideImage[] {
    const index = items.findIndex(item => item.id === targetId);
    if (index <= 0) {
        return [...items]; // ничего не меняем, если это первый элемент или не найдено
    }
    const newItems = [...items];
    // Меняем местами текущий элемент и предыдущий
    [newItems[index - 1], newItems[index]] = [newItems[index], newItems[index - 1]];
    return newItems;
}
function moveIdForward(items: SlideImage[], targetId: string): SlideImage[] {
    const index = items.findIndex(item => item.id === targetId);
    if (index < 0 || index >= items.length - 1) {
        return [...items]; // ничего не меняем, если это последний элемент или не найдено
    }
    const newItems = [...items];
    // Меняем местами текущий элемент и следующий
    [newItems[index], newItems[index + 1]] = [newItems[index + 1], newItems[index]];
    return newItems;
}

const LinkEditModal: React.FC<LinkEditModalProps> = ({ isOpen, onClose, onSaveLink, link, slideId, projectId }) => {
    const [linkType, setLinkType] = useState('');
    const [linkData, setLinkData] = useState<LinkEdit | null>(null);
    const [slides, setSlides] = useState<Slide[]>([]);
    const [linkSlides, setLinkSlides] = useState<LinkSlide[]>([]);
    const [files, setFiles] = useState([]);
    const [selectedItem, setSelectedItem] = useState('');
    const [siteUrl, setSiteUrl] = useState('');
    const [isSlideSelectionModalOpen, setIsSlideSelectionModalOpen] = useState(false);
    const [isAllSlideSelectionModalOpen, setAllIsSlideSelectionModalOpen] = useState(false);
    const [isMultiSlideSelectionModalOpen, setIsMultiSlideSelectionModalOpen] = useState(false);
    const [slidesImages, setSlidesImages] = useState<SlideImage[]>([]);
    const [projectSlides, setProjectSlides] = useState<Slide[]>([]);
    const [presentations, setPresentations] = useState<Presentation[]>([]);
    const [scenarios, setScenarios] = useState<Scenario[]>([]);
    const [selectedProject, setSelectedProject] = useState<string>('');
    const [multiDirections, setMultiDirections] = useState<MultiDirection[]>([]);
    const [selectedScenario, setSelectedScenario] = useState<string>('');
    const [selectedFromVisit, setSelectedFromVisit] = useState<string>('');
    const [selectedToVisit, setSelectedToVisit] = useState<string>('');
    const [scenarioVisits, setScenarioVisits] = useState<Visit[]>([]);
    const [visits, setVisits] = useState<Visit[]>([]);


    const fetchMultiDirections = async () => {
        try {
            const response = await getMultiDirections(link.id);
            setMultiDirections(response);
        } catch (error) {
            console.error('Error fetching slides:', error);
        }
    };
    const fetchSlides = async () => {
        try {
            const response = await getSlides(projectId);
            setSlides(response.items);
        } catch (error) {
            console.error('Error fetching slides:', error);
        }
    };
    // const fetchLink = async () => {
    //     try {
    //         const response = await getLink(link.id as string);
    //         setLinkSlides(response.items);
    //     } catch (error) {
    //         console.error('Error fetching slides:', error);
    //     }
    // };
    const fetchLinkSlides = async () => {
        try {
            console.log(link)
            if (link !== null){
                const response = await getLinkSlides(link.id as string);
                setLinkSlides(response.items);
                const getslides:LinkSlide[]  = response.items
                var slide_images: SlideImage[] = [];
                getslides.forEach(slide => {
                    slide_images.push({id: slide.slide.id, url: slide.slide.preview})
                });
                setSlidesImages(slide_images)
                console.log(slide_images)
            }

            // console.log(response.items)
        } catch (error) {
            console.error('Error fetching slides:', error);
        }
    };
    useState(() => {
        if (link === null){
            setLinkType('popup')
            setSelectedItem('');
            setSiteUrl('')
        }else{
            setLinkType(link.link_type)
            setSiteUrl(link.url)
            if (linkType)
                fetchLinkSlides()
                // fetchMultiDirections()
        }
    });
    const loadPresentations = async () => {
        const data = await fetchProjects(1, 100);
        setPresentations(data.items);
    };
    const loadScenarios = async () => {
        const data = await getScenarios(1, 200);
        setScenarios(data.items);
    };
    const fetchProjectSlides = async (projectId: string) => {
        try {
            const response = await getSlides(projectId);
            setProjectSlides(response.items);
        } catch (error) {
            console.error('Ошибка при получении слайдов проекта:', error);
        }
    };
    const handleProjectChange = (event: SelectChangeEvent<string>) => {
        const projectId = event.target.value;
        setSelectedProject(projectId);
        fetchProjectSlides(projectId);
    };
    const handleScenarioChange = async (event: SelectChangeEvent<string>) => {
        const scenarioId = event.target.value;
        setSelectedScenario(scenarioId);
        try {
            const response = await getVisits(scenarioId, 1, 100);
            setVisits(response.items);
        } catch (error) {
            console.error('Error fetching slides:', error);
        }
    };
    const handleFromVisitChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectedFromVisit(visitId);
    };
    const handleToVisitChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectedToVisit(visitId);
    };

    useEffect(() => {
        if (link !== null){
            if (link.id) {
                // Fetch existing link data and populate the form
            } else {
                // Reset form for new link
                setLinkType('');
                setSelectedItem('');
                setSiteUrl('');
            }
        }

    }, [link]);




    useEffect(() => {
        if (linkType === 'multipopup') {
            loadPresentations()
            fetchLinkSlides()
            fetchSlides()
            // getSlides(projectId).then(setSlides);
        } else if (linkType === 'popup' || linkType === 'direction') {
            fetchLinkSlides()
            fetchSlides()
            // getSlides(projectId).then(setSlides);
        } else if (linkType === 'multidirection') {
            fetchMultiDirections()
            loadScenarios()
        } else if (['video', 'audio', 'pdf'].includes(linkType)) {
            // fetchFiles(linkType).then(setFiles);
        }
    }, [linkType]);

    const handleSave = async () => {
        var slide_images: string[] = [];
        if (linkType === 'popup' || linkType === 'multipopup' || linkType === 'direction' || linkType === 'multidirection') {
            slidesImages.forEach(img => {
                slide_images.push(img.id)
            });
            // await addSlideToLink(link.id, slide_images)
        }

        console.log(slidesImages)

        var linkDataVal: LinkEdit = {
            id: null,
            link_type: linkType,
            name: '',
            url: linkType === 'site' ? siteUrl : selectedItem,
            slide_id: slideId
        };
        if (link !== null){
            linkDataVal = {
                id: link.id,
                link_type: linkType,
                name: '',
                url: linkType === 'site' ? siteUrl : selectedItem,
                slide_id: slideId
            };
        }



        setLinkData(linkDataVal)

        // if (link.id) {
        //     await updateLink(link.id, linkData);
        // } else {
        //     // await createLink(linkData);
        // }

        onSaveLink(linkDataVal, slidesImages);
    };
    const handleSlideImages = async (slidesImage: string, slideId: string) => {
        var imagesList = slidesImages
        imagesList.push({ url: slidesImage, id: slideId})
        setSlidesImages(imagesList)
        setIsSlideSelectionModalOpen(false)
        setIsMultiSlideSelectionModalOpen(false)
        setAllIsSlideSelectionModalOpen(false)
    }
    const handleDelete = async (slideId: string) => {
        // console.log(link)
        await deleteLinkSlide(link.id, slideId);
        fetchLinkSlides()
        // var imagesList = slidesImages
        // imagesList.push({ url: slidesImage, id: slideId})
        // setSlidesImages(imagesList)
        // setIsSlideSelectionModalOpen(false)
    }
    const handleDeleteMultiDirection = async (multiDirectionId: string) => {
        await deleteMultiDirection(multiDirectionId);
        fetchMultiDirections()
    }

    const handlePrev = async (slideId: string) => {
        const list: SlideImage[] = moveIdBack(slidesImages, slideId)
        setSlidesImages(list)

    }
    const handleNext = async (slideId: string) => {
        const list: SlideImage[] = moveIdForward(slidesImages, slideId)
        setSlidesImages(list)
    }

    const handleAddSlideToLink = async (slideId: string) => {
        setIsSlideSelectionModalOpen(false);
        try {

            // await addSlideToLink(link.id, slideId);
            // fetchLinkSlides()
        } catch (error) {
            console.error('Error adding slide to chapter:', error);
        }
    };

    const handleAddMultiDirection = async () => {
        const addData = {
            link_id: link.id,
            scenario_id: selectedScenario,
            from_visit_id: selectedFromVisit,
            to_visit_id: selectedToVisit
        }
        await addMultiDirection(addData);
        setIsMultiSlideSelectionModalOpen(false)
        fetchMultiDirections()
    };


    return (
        <>
            <Modal open={isOpen} onClose={()=>onClose()}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 600 }}>
                    <Typography variant="h6" component="h2" gutterBottom>
                        {link !== null ? 'Редактирование ссылки' : 'Создание ссылки'}
                    </Typography>
                    <Select
                        value={linkType}
                        onChange={(e) => {setLinkType(e.target.value); setSlidesImages([])}}
                        fullWidth
                        margin="none"
                    >
                        <MenuItem value="popup">Popup</MenuItem>
                        <MenuItem value="multipopup">Multi Popup</MenuItem>
                        <MenuItem value="direction">Direction</MenuItem>
                        <MenuItem value="multidirection">Multi Direction</MenuItem>
                        {/*<MenuItem value="video">Video</MenuItem>*/}
                        {/*<MenuItem value="audio">Audio</MenuItem>*/}
                        {/*<MenuItem value="pdf">PDF</MenuItem>*/}
                        {/*<MenuItem value="site">Site</MenuItem>*/}
                    </Select>

                    {(linkType === 'popup' || linkType === 'direction') && (
                        <Box>
                            <List sx={{display:'flex', flexWrap:'wrap', gap: 1}}>
                                {slidesImages.map((slideitem) => (
                                    <Box className='addModalSlideItem' key={slideitem.id}
                                         sx={{
                                             position: 'relative',
                                             '&:hover .deleteButton': {opacity: 1},
                                             '&:hover .prevButton': {opacity: 1},
                                             '&:hover .nextButton': {opacity: 1}
                                         }}>
                                        <img src={slideitem.url}/>
                                        {slidesImages.length > 1 && (
                                        <>
                                            <IconButton
                                                className="prevButton"
                                                sx={{
                                                    position: 'absolute',
                                                    top: 5,
                                                    left: 5,
                                                    opacity: 0,
                                                    transition: 'opacity 0.2s',
                                                    color: '#fff',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                                    '&:hover': {backgroundColor: 'rgba(0, 0, 0, 0.9)'}
                                                }}
                                                onMouseDown={(e) => e.stopPropagation()}
                                                onMouseUp={(e) => {e.stopPropagation(); handlePrev(slideitem.id);}}
                                                // onClick={handleDelete}
                                            >
                                                <ArrowLeft/>
                                            </IconButton>
                                            <IconButton
                                                className="nextButton"
                                                sx={{
                                                    position: 'absolute',
                                                    top: 5,
                                                    left: 50,
                                                    opacity: 0,
                                                    color: '#fff',
                                                    transition: 'opacity 0.2s',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                                    '&:hover': {backgroundColor: 'rgba(0, 0, 0, 0.9)'}
                                                }}
                                                onMouseDown={(e) => e.stopPropagation()}
                                                onMouseUp={(e) => {e.stopPropagation(); handleNext(slideitem.id);}}
                                                // onClick={handleDelete}
                                            >
                                                <ArrowRight/>
                                            </IconButton>
                                        </>
                                            )}

                                        <IconButton
                                            className="deleteButton"
                                            sx={{
                                                position: 'absolute',
                                                top: 5,
                                                right: 5,
                                                opacity: 0,
                                                transition: 'opacity 0.2s',
                                                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                                '&:hover': {backgroundColor: 'rgba(255, 255, 255, 0.9)'}
                                            }}
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onMouseUp={(e) => {e.stopPropagation(); handleDelete(slideitem.id);}}
                                            // onClick={handleDelete}
                                        >
                                            <Delete/>
                                        </IconButton>
                                    </Box>
                                ))}
                            </List>

                            <Button onClick={() => {
                                setIsSlideSelectionModalOpen(true)
                            }}>
                                <ListItemText primary="Add new slide" />
                            </Button>
                        </Box>

                    )}

                    {(linkType === 'multipopup') && (
                        <Box>
                            <List sx={{display:'flex', flexWrap:'wrap', gap: 1}}>
                                {slidesImages.map((slideitem) => (
                                    <Box className='addModalSlideItem' key={slideitem.id}
                                         sx={{
                                             position: 'relative',
                                             '&:hover .deleteButton': {opacity: 1},
                                             '&:hover .prevButton': {opacity: 1},
                                             '&:hover .nextButton': {opacity: 1}
                                         }}>
                                        <img src={slideitem.url}/>
                                        {slidesImages.length > 1 && (
                                        <>
                                            <IconButton
                                                className="prevButton"
                                                sx={{
                                                    position: 'absolute',
                                                    top: 5,
                                                    left: 5,
                                                    opacity: 0,
                                                    transition: 'opacity 0.2s',
                                                    color: '#fff',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                                    '&:hover': {backgroundColor: 'rgba(0, 0, 0, 0.9)'}
                                                }}
                                                onMouseDown={(e) => e.stopPropagation()}
                                                onMouseUp={(e) => {e.stopPropagation(); handlePrev(slideitem.id);}}
                                                // onClick={handleDelete}
                                            >
                                                <ArrowLeft/>
                                            </IconButton>
                                            <IconButton
                                                className="nextButton"
                                                sx={{
                                                    position: 'absolute',
                                                    top: 5,
                                                    left: 50,
                                                    opacity: 0,
                                                    color: '#fff',
                                                    transition: 'opacity 0.2s',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                                    '&:hover': {backgroundColor: 'rgba(0, 0, 0, 0.9)'}
                                                }}
                                                onMouseDown={(e) => e.stopPropagation()}
                                                onMouseUp={(e) => {e.stopPropagation(); handleNext(slideitem.id);}}
                                                // onClick={handleDelete}
                                            >
                                                <ArrowRight/>
                                            </IconButton>
                                        </>
                                            )}

                                        <IconButton
                                            className="deleteButton"
                                            sx={{
                                                position: 'absolute',
                                                top: 5,
                                                right: 5,
                                                opacity: 0,
                                                transition: 'opacity 0.2s',
                                                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                                '&:hover': {backgroundColor: 'rgba(255, 255, 255, 0.9)'}
                                            }}
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onMouseUp={(e) => {e.stopPropagation(); handleDelete(slideitem.id);}}
                                            // onClick={handleDelete}
                                        >
                                            <Delete/>
                                        </IconButton>
                                    </Box>
                                ))}
                            </List>

                            <Button onClick={() => {
                                setAllIsSlideSelectionModalOpen(true)
                            }}>
                                <ListItemText primary="Add new slide" />
                            </Button>
                        </Box>

                    )}

                    {(linkType === 'multidirection') && (
                        <Box>
                            <List>
                                {multiDirections.map((multiDirection) => (
                                    <Box className='multiDirectionsItem' key={multiDirection.id}
                                         sx={{
                                             '&:hover .deleteButton': {opacity: 1}
                                         }}>

                                        <strong>{multiDirection.scenario.name}</strong>
                                        Откуда: <b>{multiDirection.from_visit.name}</b><br/>
                                        Куда: <b>{multiDirection.to_visit.name}</b>

                                        <IconButton
                                            className="deleteButton"
                                            sx={{
                                                position: 'absolute',
                                                top: 5,
                                                right: 5,
                                                opacity: 0,
                                                transition: 'opacity 0.2s',
                                                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                                '&:hover': {backgroundColor: 'rgba(255, 255, 255, 0.9)'}
                                            }}
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onMouseUp={(e) => {e.stopPropagation(); handleDeleteMultiDirection(multiDirection.id);}}
                                        >
                                            <Delete/>
                                        </IconButton>
                                    </Box>
                                ))}
                            </List>

                            <Button onClick={() => {
                                setIsMultiSlideSelectionModalOpen(true)
                            }}>
                                <ListItemText primary="Add new multidirection" />
                            </Button>
                        </Box>

                    )}

                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={()=>onClose()} sx={{ mr: 1 }}>Cancel</Button>
                        <Button onClick={() => handleSave()} variant="contained">Save</Button>
                    </Box>
                </Box>
            </Modal>
            {/* Модальное окно выбора слайда */}
            {/*<Modal open={isAllSlideSelectionModalOpen} onClose={() => setAllIsSlideSelectionModalOpen(false)}>*/}
            {/*    <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>*/}
            {/*        <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 960, minWidth: 300, maxHeight:'90vh', overflow: 'scroll' }}>*/}
            {/*            <Box className='addModalSlideItems'>*/}
            {/*                {slides.map((slide) => (*/}
            {/*                    <Box className='addModalSlideItem' key={slide.id} onClick={()=>handleSlideImages(slide.preview, slide.id)}>*/}
            {/*                        <img src={slide.preview} alt={slide.name}/>*/}
            {/*                    </Box>*/}
            {/*                ))}*/}
            {/*            </Box>*/}
            {/*            <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>*/}
            {/*                <Box></Box>*/}
            {/*                <Button className="blueModalButton" variant="outlined" onClick={()=>setAllIsSlideSelectionModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>*/}
            {/*                    Отмена*/}
            {/*                </Button>*/}
            {/*            </Box>*/}
            {/*        </Box>*/}
            {/*    </Box>*/}
            {/*</Modal>*/}
            <Modal open={isAllSlideSelectionModalOpen} onClose={() => setAllIsSlideSelectionModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center', overflowY: 'scroll'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 960, minWidth: 300, maxHeight:'90vh', overflow: 'scroll' }}>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label">Выберите проект</InputLabel>
                            <Select
                                labelId="project-select-label"
                                id="project-select"
                                value={selectedProject}
                                label="Выберите проект"
                                onChange={handleProjectChange}
                            >
                                {presentations.map((presentation) => (
                                    <MenuItem key={presentation.id} value={presentation.id}>
                                        {presentation.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Box className='addModalSlideItems'>
                            {(selectedProject ? projectSlides : slides).map((slide) => (
                                <Box className='addModalSlideItem' key={slide.id} onClick={() => handleSlideImages(slide.preview, slide.id)}>
                                    <img src={slide.preview} alt={slide.name}/>
                                </Box>
                            ))}
                        </Box>

                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Box></Box>
                            <Button className="blueModalButton" variant="outlined" onClick={() => setAllIsSlideSelectionModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Модальное окно выбора слайда */}
            <Modal open={isSlideSelectionModalOpen} onClose={() => setIsSlideSelectionModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 960, minWidth: 300, maxHeight:'90vh', overflow: 'scroll' }}>
                        <Box className='addModalSlideItems'>
                            {slides.map((slide) => (
                                <Box className='addModalSlideItem' key={slide.id} onClick={()=>handleSlideImages(slide.preview, slide.id)}>
                                    <img src={slide.preview} alt={slide.name}/>
                                </Box>
                            ))}
                        </Box>
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Box></Box>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsSlideSelectionModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
            {/* Модальное окно выбора презентации и слайдов */}
            <Modal open={isMultiSlideSelectionModalOpen} onClose={() => setIsMultiSlideSelectionModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center', overflowY: 'scroll'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 960, minWidth: 500, maxHeight:'90vh', overflow: 'scroll' }}>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label">Выберите сценарий</InputLabel>
                            <Select
                                labelId="project-select-label"
                                id="project-select"
                                value={selectedScenario}
                                label="Выберите сценарий"
                                onChange={handleScenarioChange}
                            >
                                {scenarios.map((scenario) => (
                                    <MenuItem key={scenario.id} value={scenario.id}>
                                        {scenario.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {selectedScenario !== '' &&
                            <FormControl fullWidth sx={{mb: 2}}>
                                <InputLabel id="project-select-label">Переход из визита</InputLabel>
                                <Select
                                    labelId="project-select-label"
                                    id="project-select"
                                    value={selectedFromVisit}
                                    label="Переход из визита"
                                    onChange={handleFromVisitChange}
                                >
                                    {visits.map((visit) => (
                                        <MenuItem key={visit.id} value={visit.id}>
                                            {visit.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        }

                        {selectedScenario !== '' &&
                            <FormControl fullWidth sx={{mb: 2}}>
                                <InputLabel id="project-select-label">Переход из визита</InputLabel>
                                <Select
                                    labelId="project-select-label"
                                    id="project-select"
                                    value={selectedToVisit}
                                    label="Переход из визита"
                                    onChange={handleToVisitChange}
                                >
                                    {visits.map((visit) => (
                                        <MenuItem key={visit.id} value={visit.id}>
                                            {visit.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        }

                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="outlined" onClick={handleAddMultiDirection}>
                                Добавить
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={() => setIsMultiSlideSelectionModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>


        </>


    );
};

export default LinkEditModal;
